/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import moment from 'moment';
import { getData_Vehicle } from '@/components/report/service';
import { LoadingQuery } from '../Tables/Filter';
import { computeWeightNotAbs, computeWeights } from '@/utils/query';
import { getVolume } from '@/utils';
import GenerateCondit from '@/models/GenerateCondit';
// eslint-disable-next-line no-unused-vars
import { CALCWEIGHT, PIECE, TICKET } from '@/models/GenerateCondit/Interrelated';
import RouteEntity from '@/Entity/RouteEntity';
import PublicAggCaculate from '@/models/GenerateCondit/PublicAggCaculate';
import Queryable from '@/Entity/Tools/Queryable';
import lodash from 'lodash';
import { crudRequestGet } from '@/services/api';

const filterInHouseWeightAndInHouerVolume = (record = {}, data = [], name = '') => {
  // 获取查询分拨的名称简称
  const locationName = name.replaceAll(/(分拨中心|经营本部|省区|营运区|管理区)/g, '');
  let shipmentNameList = record.shipmentName.split('-') || [];
  // 获取查询分拨所在的位置
  let locationIndex = shipmentNameList.findIndex((item) => item.includes(locationName));
  // 除了两地卸，都用目的分拨
  const obj =
    data.find((item3) => record.siteName === (item3.nextSite || item3.planNextSite)) || {};
  let calcWeight = obj.calcWeight || 0;
  let goodsVolume = obj.goodsVolume || 0;
  // 两地卸
  if (record.dockModel === '两地卸') {
    // 两地卸查询分拨在第一个
    if (locationIndex === 0 && shipmentNameList.length === 3) {
      const { calcWeight: calcWeight1 = 0, goodsVolume: goodsVolume1 = 0 } =
        data.find((item3) => record.siteName === (item3.nextSite || item3.planNextSite)) || {};
      const { calcWeight: calcWeight2 = 0, goodsVolume: goodsVolume2 = 0 } =
        data.find((item3) => record.destSiteName === (item3.nextSite || item3.planNextSite)) || {};
      calcWeight = calcWeight1 + calcWeight2;
      goodsVolume = goodsVolume1 + goodsVolume2;
      // 两地卸查询分拨在第二个
    } else if (locationIndex === 1 && shipmentNameList.length === 3) {
      calcWeight = 0;
      goodsVolume = 0;
    }
  }
  return {
    calcWeight,
    goodsVolume,
  };
};

/**
 *
 * @param {* 交接单信息集合} filteredData
 * @param {* 在装数据 } loadingData
 * @returns
 */
const filterPendingData = (filteredData = new Map(), loadingData = []) => {
  // 在装数据
  let loadingList = [...loadingData];
  // 待发数据
  let pendingList = [];
  for (let i = 0; i < loadingData.length; i++) {
    const item = loadingData[i];
    // 交接单号详情
    const deliveryReceiptNoDetails = filteredData.get(item.taskNo) || [];
    // pda交接时间都存在 并且 不是系统默认时间
    const isAllExist =
      deliveryReceiptNoDetails &&
      deliveryReceiptNoDetails.every(
        (item) => item.receiptTime && item.receiptTime !== '2000-01-01 00:00:00',
      );
    if (isAllExist) {
      // 取出deliveryReceiptNoDetails，时间较晚的对象
      let latestItem;
      let latestTime = null;
      for (const detail of deliveryReceiptNoDetails) {
        const receiptTime = moment(detail.receiptTime);
        if (!latestTime || receiptTime.isAfter(latestTime)) {
          latestTime = receiptTime;
          latestItem = detail;
        }
      }
      // pda时间交接时间存在 & 发车时间不存在 就是待发
      if (latestItem) {
        pendingList.push({
          ...latestItem,
          receiptTime: latestItem.receiptTime,
          receiptTimeTimestamp: latestItem.receiptTime
            ? moment(latestItem.receiptTime).valueOf()
            : 0,
        });
      }
    }
  }
  loadingList = loadingList.filter(
    (item) => !pendingList.some((value) => value.taskNo === item.taskNo),
  );
  return {
    pendingList,
    loadingList,
  };
};

export default {
  namespace: 'vehicleMonitoringLoading',
  state: {
    loadingAllList: [],

    loadingList: [], // 在装
    loadedList: [], // 待装
    pendingList: [], // 待发
    loadedTotalModalVisible: false, // 已装合计弹窗
    lineData: null,

    lineInStockData: null, // 库存明细行
    productInStockCalc: [], // 库存产品结算重量
    productInStockTicket: [], // 库存产品票数
    // inStockModalVisible: false,  //库存弹窗显隐
    pendingFilter: 'all',
  },
  effects: {
    *getLoadingData(_, { call, put, select }) {
      let query = yield select(({ vehicleMonitoring }) => {
        // 模拟重复车辆
        // vehicleMonitoring.planDepartureCarsItem.push({
        //   ...vehicleMonitoring.planDepartureCarsItem.find(m => m.taskNo === 'SHY20220104114'), // 取现有列表中任务号
        //   planTime: '2022-01-02 15:53:32'
        // })
        //#region 去重,保留 planTime计划发车时间在前面(小)的
        // 克隆新数组与新对象，避免原地 sort 及后续修改污染 state 引用
        let planDepartureCarsItem = (vehicleMonitoring.planDepartureCarsItem || [])
          .map((item) => ({ ...item }))
          .sort((f, l) => {
            const compart = moment(f.planTime).valueOf() - moment(l.planTime).valueOf();
            return compart;
          });
        planDepartureCarsItem = lodash.uniqWith(
          planDepartureCarsItem,
          (f, l) => f.taskNo === l.taskNo,
        );
        //#endregion

        return {
          /** 计划发出 */
          planDepartureCarsItem: planDepartureCarsItem,
          volumeItem: vehicleMonitoring.volumeItem,
          centerFilter: vehicleMonitoring.centerFilter,
          startDate: moment(vehicleMonitoring.dateRange2[0]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
          endDate: moment(vehicleMonitoring.dateRange2[1]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
        };
      });

      if (query.planDepartureCarsItem.length > 0) {
        const taskNos = query.planDepartureCarsItem.map((item) => item.taskNo);
        const nextSiteCodes = [
          ...query.planDepartureCarsItem.map((item) => item.siteCode),
          ...query.planDepartureCarsItem.map((item) => item.destSiteCode),
        ];
        const filter = LoadingQuery({
          scanSiteCode: query.centerFilter?.code,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: taskNos,
          nextSiteCodes: nextSiteCodes,
        });
        const results = [];
        for (let i = 0; i < filter.length; i++) {
          const d = yield call(getData_Vehicle, filter[i]);
          results.push(d || []);
        }
        // 定时达,库存,装载率分组
        query.planDepartureCarsItem.forEach((item) => {
          const carTypeName = item.carTypeName?.replace('米', '');
          item.toTalVolume = carTypeName && getVolume[carTypeName];
          results.forEach((item2, index2) => {
            let obj;
            switch (index2) {
              case 0:
                let filter = item2.filter((item3) => item.taskNo === item3.taskNo);
                if (filter.length) {
                  obj = { calcWeight: 0, goodsVolume: 0, deliveryReceiptNo: '' };
                }
                filter.forEach((item) => {
                  obj.calcWeight += item?.calcWeight || 0;
                  obj.goodsVolume += item?.goodsVolume || 0;
                  obj.deliveryReceiptNo += item?.deliveryReceiptNo + '\n';
                });
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                // item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj ? Math.abs(obj.goodsVolume?.toFixed(1)) : 0;
                item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo?.trim() : '';
                break;
              case 1:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj ? Math.abs(obj.goodsVolume?.toFixed(1)) : 0;
                if (index2 === 0) item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo : '';
                break;
              case 2:
              case 3:
                const { calcWeight, goodsVolume } = filterInHouseWeightAndInHouerVolume(
                  item,
                  item2,
                  query.centerFilter?.name,
                );
                item[`calcWeight${index2}`] = calcWeight;
                item[`goodsVolume${index2}`] = goodsVolume;
                break;
              case 4:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                item[`goodsWeight${index2}`] = obj ? obj.goodsWeight : 0;
              default:
                break;
            }
          });
          item.planTime2 = item.planTime ? moment(item.planTime).format('MM/DD HH:mm') : '--';
        });
        // 计算
        query.planDepartureCarsItem.forEach((item, index) => {
          item.index = index;
          // 本站已装合计
          item.totalWeight = computeWeights(item.calcWeight0);
          // 本站已装定时达
          item.timeWeight = computeWeights(item.calcWeight1);
          const calcWeight4 = computeWeights(item.calcWeight4); // 车辆已装货量: 可能还有发往下一站没有卸车的
          const goodsWeight4 = computeWeights(item.goodsWeight4); // 车辆已装货量: 可能还有发往下一站没有卸车的
          // 剩余可用运力   总运力-车辆已装货量
          item.volume =
            item.toTalVolume && Number.parseFloat((item.toTalVolume - goodsWeight4).toFixed(1));
          // 装载率(车辆已装货量)/总运力
          item.rateVolume = item.toTalVolume
            ? ((Number(calcWeight4) / item.toTalVolume) * 100).toFixed(1)
            : '';
          // 在库
          item.inHouseWeight = computeWeights(item.calcWeight2 + item.calcWeight3);
          item.inHouerVolume = Number.parseFloat(
            Math.abs((item.goodsVolume2 || 0) + (item.goodsVolume3 || 0)).toFixed(1),
          );
          item.planTimeTimestamp = item.planTime ? moment(item.planTime).valueOf() : 0;
        });
      }
      yield put({
        type: 'update',
        payload: {
          loadingAllList: query.planDepartureCarsItem,
        },
      });
      yield put({ type: 'getTimes' });
    },
    // 在装和待发
    *getTimes(_, { put, select }) {
      // 获取时间差
      const { loadingAllList } = yield select(
        ({ vehicleMonitoringLoading }) => vehicleMonitoringLoading,
      );

      // 克隆新数组与新对象，避免直接修改 state 引用导致视图不刷新
      const newLoadingAllList = (loadingAllList || []).map((item) =>
        item && typeof item === 'object' ? { ...item } : item,
      );

      let loadingData = []; // 在装
      let pendingData = []; // 待发
      if (newLoadingAllList.length > 0) {
        for (let i = 0; i < newLoadingAllList.length; i++) {
          const now = moment(new Date()); // 当前时间
          const time = moment(newLoadingAllList[i].planTime); // 预计发车时间
          if (now.valueOf() === time.valueOf()) {
            newLoadingAllList[i] = '已出发';
            break;
          }
          const dur = time - now;
          let tempTime = moment.duration(dur);
          const _days = tempTime.days();
          const _hours = tempTime.hours();
          const _minutes = tempTime.minutes();
          const days = _days !== 0 ? Math.abs(_days) : null;
          const hours = Math.abs(_hours);
          const minutes = Math.abs(_minutes);

          let durTime = '';
          if (_days < 0 || _hours < 0 || _minutes < 0) {
            durTime = '延误:';
          }
          durTime += `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${
            minutes ? minutes + '分' : ''
          }`;
          newLoadingAllList[i].durTime = durTime;
        }
        loadingData = newLoadingAllList.filter((item) => item.deliveryReceiptNo);
      }
      // deliveryReceiptNo交接单号存在可能是 待发 或 在装
      if (loadingData && loadingData.length > 0) {
        // 获取交接单号
        let numberList = [];
        const list = loadingData.map((v) => v.deliveryReceiptNo);
        list.forEach((item) => {
          const splitItems = item.split('\n');
          numberList = numberList.concat(splitItems);
        });

        const filteredData = new Map();
        const preeCount = 40; // 每次请求交接单信息条数

        // 分批量查询接单号详情
        for (let first = 0; first < numberList.length; first += preeCount) {
          let last = first + preeCount;
          if (last > numberList.length) last = numberList.length;
          const deliverList = numberList.slice(first, last);
          const result = yield crudRequestGet(
            `/api/v1/track/receipt/infoDetail?deliveryNoList=${deliverList.toString()}`,
            { module: 'maxcenterbusi' },
          );
          if (result && result?.data.length > 0) {
            // 查询的交接单号根据任务号taskNo分组
            result.data.forEach((item) => {
              const { taskNo } = item;
              if (!filteredData.has(taskNo)) {
                filteredData.set(taskNo, []);
              }
              const obj = loadingData.find((item) => item.taskNo === taskNo);
              filteredData.get(taskNo).push({ ...item, ...obj });
            });
          }
        }
        const { loadingList, pendingList } = filterPendingData(filteredData, loadingData);
        loadingData = loadingList;
        pendingData = pendingList;
      }
      yield put({
        type: 'update',
        payload: {
          loadingList: loadingData,
          pendingList: pendingData,
        },
      });
    },
    // 在装在库详情
    *getInStockDetail({ payload: { lineInStockData } }, { put, select }) {
      yield put({ type: 'update', payload: { lineInStockData } });
      let query = yield select(({ vehicleMonitoring }) => {
        return {
          /** 计划发出 */
          centerFilter: vehicleMonitoring.centerFilter,
          startDate: moment(vehicleMonitoring.dateRange2[0]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
          endDate: moment(vehicleMonitoring.dateRange2[1]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
        };
      });

      const gc = new GenerateCondit({
        dataSource: 'actual_load_unload_result',
        dimensions: ['productType'],
        aggregators: [CALCWEIGHT, TICKET],
        startDate: query.startDate,
        endDate: query.endDate,
      });
      const caculate = new PublicAggCaculate(gc);
      const entity = new RouteEntity({
        scanSiteCode: query.centerFilter?.code,
        nextSiteCode: lineInStockData?.siteCode,
        productType: { notValue: '整车' },
      });
      const stockDataResult = yield caculate.getStockData(entity, -3); // 查询库存
      const stockData = new Queryable(stockDataResult);
      // 如果是两地卸查询destSiteCode
      let productInStock2 = null;
      if (lineInStockData.dockModel === '两地卸') {
        const caculate2 = new PublicAggCaculate(gc);
        const entity2 = new RouteEntity({
          scanSiteCode: query.centerFilter?.code,
          nextSiteCode: lineInStockData?.destSiteCode,
          productType: { notValue: '整车' },
        });
        const stockDataResult2 = yield caculate2.getStockData(entity2, -3);
        const stockData2 = new Queryable(stockDataResult2);
        productInStock2 = stockData2
          .GroupByField('productType')
          .AggreObject(['calcWeight', 'ticket']);
      }

      // 产品类型
      let productInStock = stockData
        .GroupByField('productType')
        .AggreObject(['calcWeight', 'ticket']);
      const productInStockCalc = []; // 产品类型重量
      const productInStockTicket = []; // 产品类型票数
      // 两地卸
      if (productInStock2) {
        productInStock.forEach((item) => {
          productInStock2.forEach((value) => {
            const calcWeight1 = computeWeightNotAbs(item.calcWeight);
            const calcWeight2 = computeWeightNotAbs(value.calcWeight);
            if (
              (calcWeight1 > 0.01 || calcWeight1 === 0) &&
              (calcWeight2 > 0.01 || calcWeight2 === 0) &&
              item.productType === value.productType
            ) {
              productInStockCalc.push({
                name: item.productType,
                value: (calcWeight1 * 10000 + calcWeight2 * 10000) / 10000,
              });
            }
            if (
              Number.parseInt(item.ticket) >= 0 &&
              Number.parseInt(value.ticket) >= 0 &&
              item.productType === value.productType
            ) {
              productInStockTicket.push({
                name: item.productType,
                value: item.ticket + value.ticket,
              });
            }
          });
        });
      } else {
        productInStock.forEach((item) => {
          const calcWeight = computeWeightNotAbs(item.calcWeight);
          if (calcWeight > 0.01) {
            productInStockCalc.push({ name: item.productType, value: calcWeight });
          }
          if (Number.parseInt(item.ticket) > 0) {
            productInStockTicket.push({ name: item.productType, value: item.ticket });
          }
        });
      }

      yield put({ type: 'update', payload: { productInStockCalc, productInStockTicket } });
    },
    // 待装
    *getLoadedData(_, { call, put, select }) {
      let query = yield select(({ vehicleMonitoring }) => {
        // 克隆新数组与新对象，避免原地 sort 及后续修改污染 state 引用
        let loadedItem = (vehicleMonitoring.loadedItem || [])
          .map((item) => ({ ...item }))
          .sort((f, l) => {
            const compart = moment(f.planTime).valueOf() - moment(l.planTime).valueOf();
            return compart;
          });
        loadedItem = lodash.uniqWith(loadedItem, (f, l) => f.taskNo === l.taskNo);
        //#endregion
        return {
          /** 计划发出 */
          loadedItem: loadedItem,
          centerFilter: vehicleMonitoring.centerFilter,
          startDate: moment(vehicleMonitoring.dateRange3[0]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
          endDate: moment(vehicleMonitoring.dateRange3[1]).format(
            vehicleMonitoring.defualtDateFormat,
          ),
          isOnlyShow: vehicleMonitoring.isOnlyShow,
        };
      });

      if (query.loadedItem.length > 0) {
        const taskNos = query.loadedItem.map((item) => item.taskNo);
        const filter = LoadingQuery({
          scanSiteCode: query.centerFilter?.code,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: taskNos,
          nextSiteCodes: [],
        });
        const results = [];
        for (let i = 0; i < filter.length; i++) {
          const d = yield call(getData_Vehicle, filter[i]);
          results.push(d || []);
        }
        // 定时达,库存,装载率分组
        query.loadedItem.forEach((item) => {
          const carTypeName = item.carTypeName?.replace('米', '');
          item.toTalVolume = carTypeName && getVolume[carTypeName];
          results.forEach((item2, index2) => {
            let obj;
            switch (index2) {
              case 0:
                let filter = item2.filter((item3) => item.taskNo === item3.taskNo);
                if (filter.length) {
                  obj = { calcWeight: 0, goodsVolume: 0, deliveryReceiptNo: '' };
                }
                filter.forEach((item) => {
                  obj.calcWeight += item?.calcWeight || 0;
                  obj.goodsVolume += item?.goodsVolume || 0;
                  obj.deliveryReceiptNo += item?.deliveryReceiptNo + '\n';
                });
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                // item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj ? Math.abs(obj.goodsVolume?.toFixed(1)) : 0;
                item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo?.trim() : '';
                break;
              case 1:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj ? Math.abs(obj.goodsVolume?.toFixed(1)) : 0;
                if (index2 === 0) item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo : '';
                break;
              case 2:
              case 3:
                const { calcWeight, goodsVolume } = filterInHouseWeightAndInHouerVolume(
                  item,
                  item2,
                  query.centerFilter?.name,
                );
                item[`calcWeight${index2}`] = calcWeight;
                item[`goodsVolume${index2}`] = goodsVolume;
                break;
              case 4:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
                item[`goodsWeight${index2}`] = obj ? obj.goodsWeight : 0;
              default:
                break;
            }
          });
          item.planTime2 = item.planTime ? moment(item.planTime).format('MM/DD HH:mm') : '--';
        });
        // 计算
        query.loadedItem.forEach((item, index) => {
          item.index = index;
          // 本站已装合计
          item.totalWeight = computeWeights(item.calcWeight0);
          // 本站已装定时达
          item.timeWeight = computeWeights(item.calcWeight1);
          const calcWeight4 = computeWeights(item.calcWeight4); // 车辆已装货量: 可能还有发往下一站没有卸车的
          const goodsWeight4 = computeWeights(item.goodsWeight4); // 车辆已装货量: 可能还有发往下一站没有卸车的
          // 剩余可用运力   总运力-车辆已装货量
          item.volume =
            item.toTalVolume && Number.parseFloat((item.toTalVolume - goodsWeight4).toFixed(1));
          // 装载率(车辆已装货量)/总运力
          item.rateVolume = item.toTalVolume
            ? ((Number(calcWeight4) / item.toTalVolume) * 100).toFixed(1)
            : '';
          // 在库
          item.inHouseWeight = computeWeights(item.calcWeight2 + item.calcWeight3);
          item.inHouerVolume = Number.parseFloat(
            Math.abs((item.goodsVolume2 || 0) + (item.goodsVolume3 || 0)).toFixed(1),
          );
          item.planTimeTimestamp = item.planTime ? moment(item.planTime).valueOf() : 0;
        });
      }
      let loadedData = [];
      if (query.loadedItem.length > 0) {
        for (let i = 0; i < query.loadedItem.length; i++) {
          const now = moment(new Date()); // 当前时间
          const time = moment(query.loadedItem[i].planTime); // 预计发车时间
          if (now.valueOf() === time.valueOf()) {
            query.loadedItem[i] = '已出发';
            break;
          }
          const dur = time - now;
          let tempTime = moment.duration(dur);
          const _days = tempTime.days();
          const _hours = tempTime.hours();
          const _minutes = tempTime.minutes();
          const days = _days !== 0 ? Math.abs(_days) : null;
          const hours = Math.abs(_hours);
          const minutes = Math.abs(_minutes);

          let durTime = '';
          if (_days < 0 || _hours < 0 || _minutes < 0) {
            durTime = '延误:';
          }
          durTime += `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${
            minutes ? minutes + '分' : ''
          }`;
          query.loadedItem[i].durTime = durTime;
        }
        loadedData = query.loadedItem
          .filter((item) => !item.deliveryReceiptNo)
          .filter((item) => {
            if (query.isOnlyShow && item.dockModel === '两地卸') {
              const searchName = query?.centerFilter?.name?.replace('分拨中心', '');
              return item.shipmentName.split('-')?.[0] === searchName;
            }
            return true;
          });
      }
      yield put({
        type: 'update',
        payload: {
          loadedList: loadedData,
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
